import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventService} from "../../../shared/services/event.service";
import {ServerService} from "../../../shared/services/server.service";
import {ToastrService} from 'ngx-toastr';
import {
  IOrganizationInfoSearch,
  IOrganizationTypeShortName,
  ISelectItemEvent,
  OrganizationService,
  TypeIds
} from './organizations.service';
import {ICurator, IDeveloper} from '../../../shared/models/models';

@Component({
  selector: 'app-select-item',
  templateUrl: './select-item.component.html',
  styleUrls: ['./select-item.component.scss'],
})
export class SelectItemComponent implements OnInit {

  @Input() key: IOrganizationTypeShortName | any = null;
  @Input() regionID: number = null;
  @Input() activeItem: IDeveloper | IOrganizationInfoSearch = null;
  @Input() activeCurators: ICurator[] = [];
  @Output() selectItem = new EventEmitter<ISelectItemEvent>();
  @Output() selectCurator = new EventEmitter<ICurator>();

  @Output() closed = new EventEmitter<boolean>();

  items: IOrganizationInfoSearch[] | IDeveloper[] | ICurator[] | any[] = [];

  editableOrganization: IOrganizationInfoSearch = null;
  editingOrganizationBIN: string = null;

  constItems: IOrganizationInfoSearch[] | IDeveloper[] = [];
  search: string = '';

  loading: boolean = true;

  showEditOrganizationModal: boolean  = false;

  constructor(private eventService: EventService, private organizationService: OrganizationService,
              private serverService: ServerService, public toastr: ToastrService) { }

  ngOnInit() {
    this.getItems();
  }


  getItems() {
    if (TypeIds[this.key]) {
      this.organizationService.getOrganizations(Number(TypeIds[this.key])).subscribe((res: IOrganizationInfoSearch[]) => {
        this.items = res;

        if (this.activeItem) {
          let findedIndex = (this.items as IOrganizationInfoSearch[]).findIndex(item => item.bin === this.activeItem.bin);
          if (findedIndex !== -1) {
            (this.items[findedIndex] as IOrganizationInfoSearch).active = true;
            let elems = this.items.splice(findedIndex, 1) as IOrganizationInfoSearch[];
            (this.items as IOrganizationInfoSearch[]).unshift(elems[0] as IOrganizationInfoSearch);
            this.activeItem = this.items[0] as IOrganizationInfoSearch;
          }
        }
        this.loading = false;
      });
    } else if (this.key === 'supervisor') {
        this.serverService.getSupervisors(this.regionID).then((res: IDeveloper[]) => {
          this.items = res;
          this.constItems = this.items;

          if (this.activeItem) {
            let findedIndex = (this.items as IDeveloper[]).findIndex(item => item.id === (this.activeItem as IDeveloper).id);
            if (findedIndex !== -1) {
              (this.items[findedIndex] as IDeveloper).active = true;
              let elems = (this.items as IDeveloper[]).splice(findedIndex, 1) as IDeveloper[];
              (this.items as IDeveloper[]).unshift(elems[0] as IDeveloper);
              this.activeItem = this.items[0];
            }
          }

          this.loading = false;
        });
    } else if (this.key === 'curators') {
      this.serverService.getCurators().then(res => {
        this.items = res;
        if (this.activeCurators.length > 0) {
          (this.items as ICurator[]).map(elem => {
            if (this.activeCurators.findIndex(x => x.userId === elem.userID) !== -1) {
              elem.active = true;
            }
            return elem;
          });

          if ((this.items as ICurator[]).some(x => x.active)) {
            this.items = (this.items as ICurator[]).sort((a: ICurator, b: ICurator) => {
              return (a.active === b.active)? 0 : a.active ? -1 : 1;
            });
          }
        }

        this.loading = false;
      });
    }
  }

  setItemForAll(item: IOrganizationInfoSearch) {
    this.loading = true;
    this.selectItem.emit({
      key: this.key,
      value: {
        typeID: Number(TypeIds[this.key]),
        title: item.title,
        bin: item.bin
      }
    });
    this.loading = false;
    this.eventService.disableBodyScrollbar.emit(true);
  }

  setItemSupervisor(item: IDeveloper) {
    this.loading = true;
    this.selectItem.emit({
      key: this.key,
      value: {
        id: item.id,
        name: item.name,
        phone: item.phone
      }
    });
    this.loading = false;
    this.eventService.disableBodyScrollbar.emit(true);
  }

  setItemCurator(item: ICurator) {
    this.loading = true;
    this.selectCurator.emit({
      fullName: item.name,
      userId: item.userID
    });
    this.loading = false;
    this.eventService.disableBodyScrollbar.emit(true);
  }

  selectItemWrapper(item) {
    if (this.key === 'supervisor') {
      this.setItemSupervisor(item);
    }
    if (this.key === 'curators') {
      this.setItemCurator(item);
    }
    if (TypeIds[this.key]) {
      this.setItemForAll(item);
    }
  }

  showAddObjectModal() {
    this.showEditOrganizationModal = true;

    this.editableOrganization = null;
    this.editingOrganizationBIN = null;
  }

  editOrganization(organization: IOrganizationInfoSearch | any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    this.editableOrganization = organization;
    this.editingOrganizationBIN = organization.bin;
    this.showEditOrganizationModal = true;
  }

  // TODO: сделать через formControl
  filterItems() {
    this.loading = true;
    if (this.search.length > 0) {
      if (this.key === 'supervisor') {
        const reg = new RegExp(this.search, 'i');
        let items = (this.items as IDeveloper[]).filter(i => reg.test((i.title).replace(/['"«»]/g, '')) || reg.test((i.bin.toString())));
        this.items = items.length > 0 ? items : this.constItems;
      } else {
        let isBin: boolean = false;
        var reg = /^-?\d+$/;
        if (reg.test(Number(this.search).toString())) {
          isBin = true;
        }
        let searchFlag = !isBin;

        this.organizationService.infoSearch(this.search, searchFlag, null).subscribe(res => {
          this.items = res.filter(item => item.types.includes(Number(TypeIds[this.key])));
          this.loading = false;

          if (this.items.length === 0 && res.length === 1) {
            this.editOrganization(res[0]);
          }
        });
      }
    } else {
      this.getItems();
    }
  }

  close() {
    this.closed.emit(true);
  }

  closeAddOrganization(organizationBin: string) {
    this.showEditOrganizationModal = false;

    if (organizationBin) {
      this.search = organizationBin;

      this.editableOrganization = null;
      this.editingOrganizationBIN = null;

      this.filterItems();
    }
  }
}
